import { authGuard } from '@angular-monorepo/auth';

export const MONITORING_ROUTES = [
  {
    path: 'monitoreo',
    children: [
      {
        path: '',
        canActivate: [authGuard],
        data: { permission: 'monitoring' },
        loadComponent: () =>
          import('./pages/monitoring/monitoring.component').then((m) => m.MonitoringComponent),
      },
      {
        path: 'workflow/:id',
        canActivate: [authGuard],
        data: { permission: 'monitoring' },
        loadComponent: () =>
          import('./pages/executions/workflow-execution.component').then(
            (m) => m.WorkflowExecutionComponent,
          ),
      },
      {
        path: 'workflow/:workflowId/execution/:executionId/history',
        canActivate: [authGuard],
        data: { permission: 'monitoring' },
        loadComponent: () =>
          import('./pages/history/workflow-history.component').then(
            (m) => m.WorkflowHistoryComponent,
          ),
      },
    ],
  },
];
